import Home from "./components/Home/Home";
import Header from "./components/Header/Header";

import "./App.css";

function App() {
  return (
    <>
      <Header />
      <Home />
    </>
  );
}

export default App;
